import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useCallback, useRef, useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { webServiceClient } from "../../data/apiClient";
import * as ga from "../../lib/ga";
import useTrait from "../Common/syncUpdateState";
import { Logger } from "sass";

const MySwal = withReactContent(Swal);

const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
  });
};

const CrossReferenceComponent = (props) => {
  const xref1Clear = useRef();
  const xref2Clear = useRef();
  const xref3Clear = useRef();

  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const isProduction = process.env.NODE_ENV === "production";
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchedFields, setSearchedFields] = useState({ field1: false, field2: false, field3: false });
  const [result, setResult] = useState({
    products1: [],
    msg1: "",
    products2: [],
    msg2: "",
    products3: [],
    msg3: "",
  });

  const queryXref1 = useTrait();
  const queryXref2 = useTrait();
  const queryXref3 = useTrait();

  let xref1 = useTrait();
  let xref2 = useTrait();
  let xref3 = useTrait();

  const apiService = webServiceClient(setIsLoading);
  const router = useRouter();

  const handleInputChange1 = (q) => {
    queryXref1.set(q);
  };

  const handleInputChange2 = (q) => {
    queryXref2.set(q);
  };

  const handleInputChange3 = (q) => {
    // console.log("q3", q);
    queryXref3.set(q);
  };

  const clearAll = () => {
    // console.log("Clear All");
    setResult({
      products1: [],
      msg1: "",
      products2: [],
      msg2: "",
      products3: [],
      msg3: "",
    });
    setHasSearched(false);
    setSearchedFields({ field1: false, field2: false, field3: false });
    xref1.set("");
    xref2.set("");
    xref3.set("");
    xref1Clear.current?.clear();
    xref2Clear.current?.clear();
    xref3Clear.current?.clear();
  };

  const Xref1Set = (q) => {
    if (q[0]) xref1.set(q[0].partNo);
  };

  const Xref2Set = (q) => {
    if (q[0]) xref2.set(q[0].partNo);
  };

  const Xref3Set = (q) => {
    if (q[0]) xref3.set(q[0].partNo);
  };

  const handleSearch = useCallback(async (q) => {
    try {
      setOptions([]);
      const resp = await apiService.getXrefNumberList(q);
      if (resp != null) {
        setOptions(resp.data);
      }
    } catch (err) {
      console.log("xref error", err);
      showAlert("Unexpected error occurred doing search");
    }
  }, []);

  const submitForm = async (event) => {   
    try {
      setHasSearched(false);
      setResult({
        products1: [],
        msg1: "",
        products2: [],
        msg2: "",
        products3: [],
        msg3: "",
      });

      // Track which fields have values before searching
      const field1Value = xref1Clear?.current?.state?.text;
      const field2Value = xref2Clear?.current?.state?.text;
      const field3Value = xref3Clear?.current?.state?.text;
      
      const field1HasValue = field1Value != null && field1Value !== "";
      const field2HasValue = field2Value != null && field2Value !== "";
      const field3HasValue = field3Value != null && field3Value !== "";

      if (field1HasValue || field2HasValue || field3HasValue) {
        setSearchedFields({
          field1: field1HasValue,
          field2: field2HasValue,
          field3: field3HasValue
        });

        const resp = await apiService.getSearchProduct(
          field1Value,
          field2Value,
          field3Value
        );

        if (resp) {
          //console.log("res", resp);
          setHasSearched(true);
          setResult({
            ...result,
            products1:
              resp?.data?.productTypes1 != null
                ? resp?.data?.productTypes1.flatMap(x => x.products)
                : [],
            msg1: resp?.data?.msg1,
            products2:
              resp?.data?.productTypes2 != null
                ? resp?.data?.productTypes2.flatMap(x => x.products)
                : [],
            msg2: resp?.data?.msg2,
            products3:
              resp?.data?.productTypes3 != null
                ? resp?.data?.productTypes3.flatMap(x => x.products)
                : [],
            msg3: resp?.data?.msg3,
          });

          var typeOfEvent1 =
            resp?.data?.productTypes1 != null
              ? { msg: "Cross Ref- Item Not Found", val: xref1.get() }
              : { msg: "Cross Ref", val: xref1.get() };

          var typeOfEvent2 =
            resp?.data?.productTypes2 != null
              ? { msg: "Cross Ref- Item Not Found", val: xref2.get() }
              : { msg: "Cross Ref", val: xref2.get() };

          var typeOfEvent3 =
            resp?.data?.productTypes3 != null
              ? { msg: "Cross Ref- Item Not Found", val: xref3.get() }
              : { msg: "Cross Ref", val: xref3.get() };

          if (isProduction) {
            if (xref1.get()) {
              xref1.set("");
              if (resp?.data?.productTypes1.length == 0) {
               // console.log("Xref Not Found");
                ga.event({
                  action: xref1.get(),
                  params: {
                    event_category: "Xref Not Found",
                  },
                });
              } else {
                ga.event({
                  action: xref1.get(),
                  params: {
                    event_category: "Xref",
                  },
                });
                //console.log("Xref Found");
              }
            }

            if (xref2.get()) {
              xref2.set("");
              if (resp?.data?.productTypes2.length == 0) {
                ga.event({
                  action: xref2.get(),
                  params: {
                    event_category: "Xref Not Found",
                  },
                });
                //console.log("Xref2 Not Found");
              } else {
                ga.event({
                  action: xref2.get(),
                  params: {
                    event_category: "Xref",
                  },
                });
                //console.log("Xref2 Found");
              }
            }

            if (xref3.get()) {
              xref3.set("");
              if (resp?.data?.productTypes3.length == 0) {
                ga.event({
                  action: xref3.get(),
                  params: {
                    event_category: "Xref Not Found",
                  },
                });
                //console.log("Xref3 Not Found");
              } else {
                ga.event({
                  action: xref3.get(),
                  params: {
                    event_category: "Xref",
                  },
                });
               // console.log("Xref3  Found");
              }
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
      showAlert("Unexpected error occurred doing search");
    }
  };

  return (
    <>
      <Container>
        <div className='row d-flex justify-content-center'>
          <div className='col-md-3 my-1'>
            <AsyncTypeahead
              ref={xref1Clear}
              id='xref1'
              labelKey={(option) => `${option.partNo}`}
              isLoading={isLoading}
              onSearch={handleSearch}
              onInputChange={handleInputChange1}
              onChange={Xref1Set}
              options={options}
              placeholder='Type a Xref Number'
              renderMenuItemChildren={(option) => (
                <div key={option.partNo}>{option.itemName}</div>
              )}
              useCache={false}
            />
            {hasSearched && 
             searchedFields.field1 &&
             xref1Clear?.current?.state?.text != "" && 
             Array.isArray(result?.products1) && 
             result.products1.length === 0 && (
              <p className='p-1 fs-6 text-center m-0' style={{ color: "red" }}>
                No cross reference available for{" "}
                {xref1.get() ? xref1.get() : queryXref1.get()}
              </p>
            )}
          </div>
          <div className='col-md-3 my-1'>
            <AsyncTypeahead
              ref={xref2Clear}
              id='xref2'
              labelKey={(option) => `${option.partNo}`}
              isLoading={isLoading}
              onSearch={handleSearch}
              onInputChange={handleInputChange2}
              onChange={Xref2Set}
              options={options}
              placeholder='Type a Xref Number'
              renderMenuItemChildren={(option) => (
                <div key={option.partNo}>{option.itemName}</div>
              )}
              useCache={false}
            />
            {hasSearched && 
             searchedFields.field2 &&
             xref2Clear?.current?.state?.text != "" && 
             Array.isArray(result?.products2) && 
             result.products2.length === 0 && (
              <p className='p-1 fs-6 text-center m-0' style={{ color: "red" }}>
                No cross reference available for{" "}
                {xref2.get() ? xref2.get() : queryXref2.get()}
              </p>
            )}
          </div>
          <div className='col-md-3 my-1'>
            <AsyncTypeahead
              ref={xref3Clear}
              id='xref3'
              labelKey={(option) => `${option.partNo}`}
              isLoading={isLoading}
              onSearch={handleSearch}
              onInputChange={handleInputChange3}
              onChange={Xref3Set}
              options={options}
              placeholder='Type a Xref Number'
              renderMenuItemChildren={(option) => (
                <div key={option.partNo}>{option.itemName}</div>
              )}
              useCache={false}
            />
            {hasSearched && 
             searchedFields.field3 &&
             xref3Clear?.current?.state?.text != "" && 
             Array.isArray(result?.products3) && 
             result.products3.length === 0 && (
              <p className='p-1 fs-6 text-center m-0' style={{ color: "red" }}>
                No cross reference available for{" "}
                {xref3.get() ? xref3.get() : queryXref3.get()}
              </p>
            )}
          </div>
          <div className='btn-group col-sm-3 my-1' role='group'>
            <button
              type='submit'
              className='btn btn-primary mb-2 mx-1'
              onClick={submitForm}
            >
              Search
            </button>
            <button
              type='submit'
              className='btn btn-primary mb-2'
              onClick={clearAll}
            >
              clear
            </button>
          </div>
        </div>
      </Container>
      <Container>
        <br />
        <Row style={{ border: "1px solid #eee" }}>
          {result?.products1?.length > 0 &&
            result?.products1?.map((item, index) => (
              <Col
                className='col-sm-3'
                key={index}
                style={{ margin: "10px", border: "1px solid #eee" }}
              >
                <a href={"/part/" + item?.productCode}>
                  <div className='table-bordered img-center text-center'>
                    <Image
                      alt='Product Image'
                      responsive
                      thumbnail
                      src={item?.imageUrl}
                      layout='raw'
                      width={200}
                      height={150}
                    />
                  </div>
                </a>

                <Table
                  striped
                  bordered
                  className='table table-striped table-bordered'
                >
                  <tbody>
                    {item?.oemName && (
                      <tr>
                        <td className='ng-binding'>
                          XREF: {item?.crossRefName}
                        </td>
                      </tr>
                    )}

                    {item?.cond == "NLA" && (
                      <tr>
                        <td>
                          status:{" "}
                          <span style={{ color: 'red' }}>No Longer Available</span>
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        Interchangable With {" "}
                        <Link href={"/part/" + item?.productCode} legacyBehavior> 
                          <a
                            target='_blank'
                            rel='noopener'
                            className='ng-binding'
                          >
                            {item?.productCode}
                          </a>
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td className='ng-binding'>{item?.webDescription}</td>
                    </tr>
                    <tr>
                      <td className='ng-binding'>
                        Manufacturer: {item?.oemName}
                      </td>
                    </tr>

                    {item?.notes && (
                      <tr>
                        <td className='ng-binding'>Note: {item?.notes}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            ))}

          {result?.products2?.length > 0 &&
            result?.products2?.map((item, index) => (
              <Col
                className='col-sm-3'
                key={"cxr2" + index}
                style={{ margin: "10px", border: "1px solid #eee" }}
              >
                <a href={"/part/" + item?.productCode}>
                  <div className='table-bordered img-center text-center'>
                    <Image
                      alt='Product Image'
                      responsive
                      thumbnail
                      src={item?.imageUrl}
                      layout='raw'
                      width={200}
                      height={150}
                    />
                  </div>
                </a>
                <div className='table-responsive'>
                  <Table
                    striped
                    bordered
                    className='table table-striped table-bordered'
                  >
                    <tbody>
                      {item?.oemName && (
                        <tr>
                          <td className='ng-binding'>
                            XREF: {item?.crossRefName}
                          </td>
                        </tr>
                      )}

                      {item?.cond == "NLA" && (
                        <tr>
                          <td>
                            status:{" "}
                            <span style={{ color: 'red' }}>No Longer Available</span>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>
                          Interchangable With {" "}
                          <Link href={"/part/" + item?.productCode} legacyBehavior>
                            <a
                              target='_blank'
                              rel='noopener'
                              className='ng-binding'
                            >
                              {item?.productCode}
                            </a>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td className='ng-binding'>{item?.webDescription}</td>
                      </tr>
                      <tr>
                        <td className='ng-binding'>
                          Manufacturer: {item?.oemName}
                        </td>
                      </tr>

                      {item?.notes && (
                        <tr>
                          <td className='ng-binding'>Note: {item?.notes}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            ))}
          {result?.products3?.length > 0 &&
            result?.products3.map((item, index) => (
              <Col
                className='col-sm-3'
                key={"cxr3" + index}
                style={{ margin: "10px", border: "1px solid #eee" }}
              >
                <a href={"/part/" + item?.productCode}>
                  <div className='table-bordered img-center text-center'>
                    <Image
                      alt='Product Image'
                      responsive
                      thumbnail
                      src={item?.imageUrl}
                      layout='raw'
                      width={200}
                      height={150}
                    />
                  </div>
                </a>

                <Table className='table table-striped table-bordered'>
                  <tbody>
                    {item?.oemName && (
                      <tr>
                        <td className='ng-binding'>
                          XREF: {item?.crossRefName}
                        </td>
                      </tr>
                    )}

                    {item?.cond == "NLA" && (
                      <tr>
                        <td>
                          status:{" "}
                          <span style={{ color: 'red' }}>No Longer Available</span>
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        Interchangable With {" "}
                        <Link href={"/part/" + item?.productCode} legacyBehavior>
                          <a
                            target='_blank'
                            rel='noopener'
                            className='ng-binding'
                          >
                            {item?.productCode}
                          </a>
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td className='ng-binding'>{item?.webDescription}</td>
                    </tr>
                    <tr>
                      <td className='ng-binding'>
                        Manufacturer: {item?.oemName}
                      </td>
                    </tr>

                    {item?.notes && (
                      <tr>
                        <td className='ng-binding'>Note: {item?.notes}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            ))}
        </Row>
      </Container>
    </>
  );
};

export default CrossReferenceComponent;
